module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom"
  }, [_c('nav', {
    staticClass: "navbar",
    class: _vm.fixedNavClass,
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-minimalize minimalize-styl-2 btn btn-primary ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.navbarmini.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), (_vm.levv == 2) ? _c('ul', {
    staticClass: "nav navbar-top-links navbar-right"
  }, [(_vm.permission.indexOf('rescueServiceOrderList_addOrder') == -1) ? _c('li', {
    on: {
      "click": _vm.createRescueOrder
    }
  }, [_c('a', {
    staticClass: "new_order"
  }, [_vm._v("新建救援单")])]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('rescueServiceOrderList_orderType') == -1) ? _c('li', {
    staticClass: "dropdown hidden-xs picc_tip picc_tip_red"
  }, [_c('div', [_c('em', [_vm._v("待救援：")]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList('', 11, '')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  自动派单"), _c('span', {
    staticClass: "popup_digit embblink general"
  }, [_vm._v(_vm._s(_vm.autoDispatchNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getList.apply(null, arguments)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  人工派单 \n\t\t\t\t\t\t\t\t"), _vm._v(" "), _c('span', {
    staticClass: "popup_digit embblink",
    class: [_vm.handDispatchNo === 0 ? 'general' : 'emergency1'],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList('', 12, '')
      }
    }
  }, [_vm._v(_vm._s(_vm.handDispatchNo))]), _vm._v(" "), _c('span', {
    staticClass: "popup_digit popup_digit_bottom embblink",
    class: [_vm.handDispatchNo2 === 0 ? 'general' : 'emergency1'],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList('', 13, '')
      }
    }
  }, [_vm._v(_vm._s(_vm.handDispatchNo2))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList(1, '', 1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  预约"), _c('span', {
    staticClass: "popup_digit embblink general"
  }, [_vm._v(_vm._s(_vm.arrangeNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList(1, 13, '', 67)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t派单超时"), _c('span', {
    staticClass: "popup_digit embblink general"
  }, [_vm._v(_vm._s(_vm.dispatchTimeOutNo))])])])]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('rescueServiceOrderList_orderType') == -1) ? _c('li', {
    staticClass: "dropdown hidden-xs picc_tip picc_tip_orange"
  }, [_c('div', [_c('em', [_vm._v("已接单：")]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList(2, 65, '', 65)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t联系超时"), _c('span', {
    staticClass: "popup_digit embblink",
    class: [_vm.noContactNo === 0 ? 'general' : 'emergency1']
  }, [_vm._v(_vm._s(_vm.noContactNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList('', 21, '')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t现场前往中"), _c('span', {
    staticClass: "popup_digit embblink"
  }, [_vm._v(_vm._s(_vm.sceneHeadingNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList('', 23, '')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t现场已抵达"), _c('span', {
    staticClass: "popup_digit embblink"
  }, [_vm._v(_vm._s(_vm.sceneArrivedNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList(2, 21, '', 66)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  抵达超时"), _c('span', {
    staticClass: "popup_digit embblink"
  }, [_vm._v(_vm._s(_vm.arriveTimeoutNo))])])])]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('rescueServiceOrderList_orderType') == -1) ? _c('li', {
    staticClass: "dropdown hidden-xs  picc_tip picc_tip_green"
  }, [_c('div', [_c('em', [_vm._v("已完成：")]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getFinishedRescueList('', 31)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  司机已完成"), _c('span', {
    staticClass: "popup_digit embblink"
  }, [_vm._v(_vm._s(_vm.driverFinishedNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getFinishedRescueList('', 32)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  客户已评价"), _c('span', {
    staticClass: "popup_digit embblink"
  }, [_vm._v(_vm._s(_vm.customerReviewedNo))])]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getFinishedRescueList(4, '')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  已撤单"), _c('span', {
    staticClass: "popup_digit embblink"
  }, [_vm._v(_vm._s(_vm.orderWithdrawedNo))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.levv == 3) ? _c('ul', {
    staticClass: "nav navbar-top-links navbar-right nav_company"
  }, [(_vm.permission.indexOf('rescueServiceOrderList_orderType') == -1) ? _c('li', {
    staticClass: "dropdown hidden-xs picc_tip picc_tip_red"
  }, [_c('div', [_c('em', [_vm._v("待救援：")]), _vm._v(" "), _c('a', {
    staticClass: "right-sidebar-toggle count_info",
    attrs: {
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getRescueList('', 13, '')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t  人工派单\n\t\t\t\t\t\t\t\t  "), _vm._v(" "), _c('span', {
    staticClass: "popup_digit embblink",
    class: [_vm.handDispatchNo === 0 ? 'general' : 'emergency1']
  }, [_vm._v(_vm._s(_vm.handDispatchNo))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.levv == 1) ? _c('ul', {
    staticClass: "nav navbar-top-links navbar-right nav_company"
  }, [_c('li', {
    staticClass: "dropdown hidden-xs"
  }, [_c('a', {
    staticClass: "right-sidebar-toggle count_info",
    staticStyle: {
      "color": "rgb(0,122,180)",
      "paddingRight": "30px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showMission.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v("后台任务")])])]) : _vm._e()]), _vm._v(" "), _c('audio', {
    attrs: {
      "src": require("../../assets/remindVoice.mp3"),
      "id": "audioPlay"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "src": require("../../assets/remindVoiceRB.mp3"),
      "id": "audioPlayRB"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9bc3bb6","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ContentHeader.vue
// module id = 1626
// module chunks = 0